import { Shield, ShieldCheck, Check, X, Clock, Edit2, Trash2, Key } from 'lucide-react';

/**
 * Table row for an admin user
 */
export const AdminUserRow = ({
  admin,
  onEdit,
  onDelete,
  onToggleActive,
  onResetPassword
}) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return 'Nooit';
    return new Date(dateStr).toLocaleString('nl-NL', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <tr className="hover:bg-slate-50" data-testid={`admin-row-${admin.id}`}>
      {/* User info */}
      <td className="px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#2563EB] to-blue-600 flex items-center justify-center text-white font-bold">
            {admin.name?.charAt(0) || admin.email?.charAt(0)}
          </div>
          <div>
            <p className="font-medium text-slate-900">{admin.name}</p>
            <p className="text-sm text-slate-500">{admin.email}</p>
          </div>
        </div>
      </td>

      {/* Role */}
      <td className="px-6 py-4">
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium ${
          admin.role === 'super_admin' 
            ? 'bg-purple-100 text-purple-700' 
            : 'bg-blue-100 text-blue-700'
        }`}>
          {admin.role === 'super_admin' ? (
            <>
              <ShieldCheck size={14} />
              Super Admin
            </>
          ) : (
            <>
              <Shield size={14} />
              Editor
            </>
          )}
        </span>
      </td>

      {/* Status */}
      <td className="px-6 py-4">
        <button
          onClick={() => onToggleActive(admin)}
          className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium cursor-pointer transition-colors ${
            admin.is_active 
              ? 'bg-green-100 text-green-700 hover:bg-green-200' 
              : 'bg-red-100 text-red-700 hover:bg-red-200'
          }`}
        >
          {admin.is_active ? (
            <>
              <Check size={14} />
              Actief
            </>
          ) : (
            <>
              <X size={14} />
              Inactief
            </>
          )}
        </button>
      </td>

      {/* Last login */}
      <td className="px-6 py-4 text-sm text-slate-500">
        <span className="flex items-center gap-1.5">
          <Clock size={14} />
          {formatDate(admin.last_login)}
        </span>
      </td>

      {/* Actions */}
      <td className="px-6 py-4">
        <div className="flex items-center justify-end gap-2">
          <button
            onClick={() => onEdit(admin)}
            className="p-2 hover:bg-slate-100 rounded-lg text-slate-600 hover:text-[#2563EB] transition-colors"
            title="Bewerken"
          >
            <Edit2 size={18} />
          </button>
          <button
            onClick={() => onResetPassword(admin)}
            className="p-2 hover:bg-slate-100 rounded-lg text-slate-600 hover:text-[#2563EB] transition-colors"
            title="Wachtwoord resetten"
          >
            <Key size={18} />
          </button>
          <button
            onClick={() => onDelete(admin)}
            className="p-2 hover:bg-red-50 rounded-lg text-slate-600 hover:text-red-600 transition-colors"
            title="Verwijderen"
          >
            <Trash2 size={18} />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default AdminUserRow;
